import {
  AddUpdateWorkOrderPoRequest,
  AddWorkOrderPoRequest,
  UpdateWorkOrderPoRequest,
} from "api/models/request/work-order-po/add-update-wo-po";
import {
  IAddEditWorkOrderPo,
  IAddWorkOrderPo,
} from "mobx-stores/_models/work-order-po/work-order-po";

export const mapAddUpdateWorkOrderPoModelToAddUpdateApiRequest = (
  addEditWorkOrderPo: IAddEditWorkOrderPo,
): AddUpdateWorkOrderPoRequest => {
  return {
    date: addEditWorkOrderPo.date ?? "",
    woNumber: addEditWorkOrderPo.woNumber ?? "",
    purchaseOrderId: addEditWorkOrderPo.purchaseOrderId ?? "",
    note: addEditWorkOrderPo.note ?? "",
    poItemFirstFullPaperAmount:
      addEditWorkOrderPo.poItemFirstFullPaperAmount ?? null,
    poItemFirstPrintPaperAmount:
      addEditWorkOrderPo.poItemFirstPrintPaperAmount ?? null,
    poItemProductionAmount: addEditWorkOrderPo.poItemProductionAmount ?? 0,
    poItemSecondFullPaperAmount:
      addEditWorkOrderPo.poItemSecondFullPaperAmount ?? null,
    poItemSecondPrintPaperAmount:
      addEditWorkOrderPo.poItemSecondPrintPaperAmount ?? null,
    poItemNote: addEditWorkOrderPo.poItemNote ?? "",
    purchaseOrderItemId: addEditWorkOrderPo.purchaseOrderItemId ?? "",
    woBatchNumber: addEditWorkOrderPo.woBatchNumber ?? "",
    productionAmount: addEditWorkOrderPo.productionAmount ?? 0,
    orderNumber: addEditWorkOrderPo.orderNumber ?? undefined,
  };
};

export const mapAddWorkOrderPoModelToAddApiRequest = (
  addWorkOrderPo: IAddWorkOrderPo,
): AddWorkOrderPoRequest => {
  return mapAddUpdateWorkOrderPoModelToAddUpdateApiRequest(addWorkOrderPo);
};

export const mapUpdateWorkOrderPoModelToUpdateApiRequest = (
  updateWorkOrderPo: IAddWorkOrderPo,
): UpdateWorkOrderPoRequest => {
  return {
    ...mapAddUpdateWorkOrderPoModelToAddUpdateApiRequest(updateWorkOrderPo),
    id: updateWorkOrderPo.id ?? "",
  };
};
